@let request = $request();
@let actualDeliveryAddressValue = request?.actualDeliveryAddress;
@let canLogistAddDevices = permissionService.canLogistAddDevices$ | async;
@let canExecuteWorkflow = !$isInsideWorkflow() || $canExecuteWorkflow();
@let canLogistEditRequestsResetAddress =
  permissionService.canLogistEditRequestsResetAddress$ | async;
@let isInsideDealDetails = $isInsideDealDetails();
@let isInsideDesktopSummary = $isInsideDesktopSummary();
@let isInsideWorkflow = $isInsideWorkflow();
@let addressDiffers = isDeliveryAddressDifferentFromActual();
@let isLoading = !!(isLoading$ | async);
@let noAddress =
  !isEnteredActualDeliveryAddressVerified && !actualDeliveryAddressValue;

@if (isInsideDesktopSummary) {
  <div
    class="h-[44px] x-font-body-5-bold x-text-dark-main rounded-[22px] flex items-center actual-delivery-address-container min-w-[300px]"
    [tuiSkeleton]="isLoading"
    [ngClass]="{
      'shadow-[0px_0px_18px_0px_rgba(255,75,95,0.25)]': noAddress,
      'shadow-[0px_0px_18px_0px_rgba(248,172,89,0.25)]': addressDiffers,
    }"
    [tuiHint]="addressDiffers ? tooltipAddressDiffers : ''"
    tuiHintDirection="bottom"
    tuiHintAppearance="dark"
  >
    <tui-icon
      [style.border-width.rem]="0.25"
      icon="@tui.map-pin"
      class="mx-2"
      [ngClass]="{
        'x-text-red': noAddress,
        'x-text-green':
          isEnteredActualDeliveryAddressVerified ||
          actualDeliveryAddressValue ||
          addressDiffers,
      }"
      [tuiHint]="
        noAddress
          ? ('request_form.actual_address.validation_required' | translate)
          : ''
      "
      tuiHintAppearance="dark"
    />
    @if (actualDeliveryAddressValue && !isLoading) {
      <span
        class="w-full me-3.5 min-w-0"
        [tuiHint]="actualDeliveryAddressValue"
        tuiHintAppearance="dark"
        tuiHintDirection="top"
      >
        {{ actualDeliveryAddressValue }}
      </span>
      @if (canLogistEditRequestsResetAddress && canExecuteWorkflow) {
        <x-icon-button
          iconName="@tui.pencil"
          [iconSize]="16"
          class="me-2"
          [clickFunction]="resetActualDeliveryAddress.bind(this)"
          [size]="30"
          [tuiHint]="'request_form.actual_address.reset' | translate"
          tuiHintAppearance="dark"
        />
      }
    } @else {
      @if (!isLoading) {
        <form [formGroup]="formGroup" class="flex w-full min-w-0">
          <tui-input-inline
            class="me-3.5 min-w-0 x-font-body-3 x-text-dark cursor-pointer"
          >
            {{ 'request_form.actual_address.address_placeholder' | translate }}
            <input [formControlName]="FormFields.ActualDeliveryAddress" />
          </tui-input-inline>
        </form>

        @if (actualDeliveryAddressToSet.value) {
          @if (!isEnteredActualDeliveryAddressVerified) {
            <tui-icon
              [style.border-width.rem]="0.25"
              icon="@tui.external-link"
              class="me-2 cursor-pointer"
              (click)="openMapToVerifyAddress()"
              [tuiHint]="'request_form.actual_address.check_on_map' | translate"
              tuiHintAppearance="dark"
            />
          } @else {
            <button
              size="s"
              appearance="primary"
              tuiButton
              type="button"
              class="me-2"
              (click)="setActualDeliveryAddress$.next()"
            >
              <span class="x-font-body-5-bold">{{
                'request_form.actual_address.confirm' | translate
              }}</span>
            </button>
          }
        }
      }
    }
  </div>
} @else {
  <div
    class="x-card x-card_size_m x-white mx-auto"
    [tuiSkeleton]="isLoading"
    [ngClass]="{
      'md:w-1/2': !isInsideDealDetails && !isInsideWorkflow,
      'mt-2': isInsideDealDetails,
      'mt-4.5': !isInsideDealDetails,
    }"
  >
    @if (isInsideDealDetails) {
      <h3 class="font-bold text-[1.1875rem]/7 mb-2">
        {{ 'request_form.actual_address.actual_address' | translate }}
      </h3>
    } @else {
      <div class="x-font-body-2-bold">
        {{ 'request_form.actual_address.actual_address' | translate }}
      </div>
    }
    <section class="mt-8">
      @if (actualDeliveryAddressValue) {
        <div class="mt-10">
          <div class="text-center">
            <div class="x-font-body-3-bold x-text-dark-main">
              {{ actualDeliveryAddressValue }}
            </div>
            @if (addressDiffers) {
              <div class="x-font-body-4 mt-1">
                {{ 'request_form.actual_address.differs' | translate }}
              </div>
            }
          </div>

          @if (canLogistEditRequestsResetAddress && canExecuteWorkflow) {
            <button
              tuiButton
              type="button"
              size="m"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              class="w-full md:w-1/2 mt-7 font-normal! back outline-with-green-borders-btn flex! justify-self-center"
              (click)="resetActualDeliveryAddress$.next()"
            >
              <span class="x-font-body-4-bold">
                {{ 'request_form.actual_address.reset' | translate }}</span
              >
            </button>
          }
        </div>
      } @else {
        @if (!canLogistAddDevices || !canExecuteWorkflow) {
          <div class="text-orange-400 text-sm mt-1 text-center font-medium">
            {{ 'request_form.actual_address.no_rights_to_change' | translate }}
          </div>
        } @else {
          <form [formGroup]="formGroup" class="w-full">
            <tui-textfield class="x-font-body-3 x-text-dark">
              <input
                [formControlName]="FormFields.ActualDeliveryAddress"
                tuiInput
                [placeholder]="
                  'request_form.actual_address.address_placeholder' | translate
                "
              />
            </tui-textfield>
          </form>
          @if (actualDeliveryAddressToSet.value) {
            @if (!isEnteredActualDeliveryAddressVerified) {
              <div class="x-text-danger text-sm font-medium mt-1">
                {{
                  'request_form.actual_address.validation_required' | translate
                }}
              </div>
              <a
                href="https://maps.yandex.ru/?text={{
                  actualDeliveryAddressToSet.value
                }}&l=sat%2Cskl"
                rel="noreferrer"
                target="_blank"
                tuiButton
                type="button"
                size="m"
                appearance="outline-grayscale"
                tuiAppearanceMode="checked"
                iconEnd="@tui.external-link"
                class="w-full mt-7 font-normal! back outline-with-green-borders-btn flex! justify-self-center md:w-1/2"
                (click)="onCheckAddressButtonClick()"
              >
                <span class="x-font-body-4-bold">
                  {{ 'request_form.actual_address.check_on_map' | translate }}
                </span></a
              >
            } @else {
              <div class="x-text-green text-sm font-medium mt-1">
                {{ 'request_form.actual_address.checked' | translate }}
              </div>
              @if (
                isEnteredActualDeliveryAddressVerified && !isInsideWorkflow
              ) {
                <button
                  id="verifyButton"
                  tuiButton
                  type="button"
                  size="m"
                  class="w-full mt-7 flex! justify-self-center md:w-1/2"
                  (click)="setActualDeliveryAddress$.next()"
                >
                  <span class="py-2 x-font-body-4-bold">{{
                    'request_form.actual_address.confirm' | translate
                  }}</span>
                </button>
              }
            }
          }
        }
      }
    </section>
  </div>
}

<ng-template #tooltipAddressDiffers>
  <strong class="x-text-yellow">{{
    'request_form.actual_address.differs' | translate
  }}</strong>
</ng-template>
